import { VariantOption } from '@vsf-enterprise/sap-commerce-webservices-sdk';
import { AgnosticAttribute } from '@vue-storefront/core';

export function getVariantName(
  filterByAttributeName: string[],
  variantType: string
): string {
  return filterByAttributeName.find(
    (attribute) => variantType?.toLowerCase().search(attribute) > -1
  );
}

export function getVariantOptions(
  options: VariantOption[],
  variantName: string
): AgnosticAttribute[] {
  return options?.map((option) => {
    const qualifier = option?.variantOptionQualifiers?.find(
      (qualifier) => qualifier?.qualifier === variantName
    );
    return {
      label: qualifier?.value,
      value: { code: option?.code, qualifier }
    };
  });
}
